"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditOutbox = void 0;
const utils_1 = require("../utils");
const EDIT_OUTBOX_KEY = "hhn.message.edit-outbox";
class EditOutbox {
    constructor() {
        this.mutations = Promise.resolve();
    }
    static getInstance() {
        if (!EditOutbox.instance) {
            EditOutbox.instance = new EditOutbox();
        }
        return EditOutbox.instance;
    }
    static configure(store) {
        EditOutbox.getInstance().store = store;
    }
    isEnabled() {
        return Boolean(this.store);
    }
    save(record) {
        if (!this.store) {
            return Promise.resolve();
        }
        return this.serialise(() => __awaiter(this, void 0, void 0, function* () {
            const records = yield this.read();
            const existingIndex = records.findIndex(candidate => candidate.payload._id === record.payload._id);
            if (existingIndex === -1) {
                records.push(record);
            }
            else {
                records[existingIndex] = record;
            }
            yield this.write(records);
        }));
    }
    remove(serverMessageId) {
        if (!this.store) {
            return Promise.resolve();
        }
        return this.serialise(() => __awaiter(this, void 0, void 0, function* () {
            const records = yield this.read();
            const remaining = records.filter(record => record.payload._id !== serverMessageId);
            yield this.write(remaining);
        }));
    }
    listForChat(chatId) {
        if (!this.store) {
            return Promise.resolve([]);
        }
        return this.serialise(() => __awaiter(this, void 0, void 0, function* () {
            const records = yield this.read();
            return records.filter(record => record.chatId === chatId);
        }));
    }
    clear() {
        if (!this.store) {
            return Promise.resolve();
        }
        return this.serialise(() => __awaiter(this, void 0, void 0, function* () {
            var _a;
            yield ((_a = this.store) === null || _a === void 0 ? void 0 : _a.removeItem(EDIT_OUTBOX_KEY));
        }));
    }
    serialise(operation) {
        const result = this.mutations.then(operation, operation);
        this.mutations = result.catch(() => undefined);
        return result;
    }
    read() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            try {
                const raw = yield ((_a = this.store) === null || _a === void 0 ? void 0 : _a.getItem(EDIT_OUTBOX_KEY));
                if (!raw) {
                    return [];
                }
                const parsed = JSON.parse(raw);
                if (!Array.isArray(parsed)) {
                    return [];
                }
                const cutoff = Date.now() - utils_1.HHNConstants.OUTBOX_TTL_MS;
                return parsed.filter(record => { var _a; return ((_a = record === null || record === void 0 ? void 0 : record.payload) === null || _a === void 0 ? void 0 : _a._id) && record.sentAt >= cutoff; });
            }
            catch (_b) {
                return [];
            }
        });
    }
    write(records) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            if (records.length === 0) {
                yield ((_a = this.store) === null || _a === void 0 ? void 0 : _a.removeItem(EDIT_OUTBOX_KEY));
                return;
            }
            yield ((_b = this.store) === null || _b === void 0 ? void 0 : _b.setItem(EDIT_OUTBOX_KEY, JSON.stringify(records)));
        });
    }
}
exports.EditOutbox = EditOutbox;
